import { useEffect } from 'react';
import Index from '@/pages/index';
import { setLanguage } from 'react-switch-lang';

export default function Da() {
	const lang = 'da';
	useEffect(
		() => {
			document.documentElement.lang = lang;
		},
		[ lang ]
	);
	setLanguage('dk');
	return <Index />;
}
